import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_textarea_filled = _resolveComponent("v-textarea-filled")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createBlock(_component_v_card_text, { class: "mt-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "mb-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "3",
            class: "d-flex align-center justify-end"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("h3", null, "Titre :", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "8" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.newAudit.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newAudit.title) = $event)),
                "hide-details": "",
                outlined: "",
                label: "Titre du contrôle",
                disabled: _ctx.newAudit.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM',
                density: "compact"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "1" })
        ]),
        _: 1
      }),
      (_ctx.newAudit.data.description)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }),
              _createVNode(_component_v_col, {
                cols: "10",
                class: "d-flex align-center justify-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.newAudit.data.description), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "1" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.newAudit.data.description)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "3",
                class: "d-flex align-center justify-end"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("h3", null, "Comptes à afficher :", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_combobox_filled, {
                    modelValue: _ctx.newAudit.data.accountableAccounts,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newAudit.data.accountableAccounts) = $event)),
                    label: "Racines comptes",
                    multiple: "",
                    outlined: "",
                    "hide-details": "",
                    dense: "",
                    chips: "",
                    "deletable-chips": "",
                    "item-disabled": "",
                    disabled: _ctx.newAudit.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM'
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "1" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.newAudit.data.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newAudit.data.form.tables[0].rows, (row, index) => {
              return (_openBlock(), _createBlock(_component_v_row, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "d-flex align-center justify-end"
                  }, {
                    default: _withCtx(() => [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "Questions :"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_col, {
                    cols: "8",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_textarea_filled, {
                        modelValue: row.description,
                        "onUpdate:modelValue": ($event: any) => ((row.description) = $event),
                        "auto-grow": "",
                        rows: "1",
                        "hide-details": "",
                        outlined: "",
                        label: `Question n°${index + 1}`,
                        disabled: _ctx.newAudit.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM'
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-end"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.readOnly && _ctx.newAudit.data.form.tables[0].rows.length > 1)
                        ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                            key: 0,
                            onClick: ($event: any) => (_ctx.deleteQuestion(row)),
                            class: "mx-2 my-2",
                            size: "x-small"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "11" }),
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "d-flex align-center justify-end"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.readOnly)
                      ? (_openBlock(), _createBlock(_component_v_btn_add_icon, {
                          key: 0,
                          size: "x-small",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addQuestion())),
                          disabled: 
                            !_ctx.newAudit.data.form.tables[0].rows[
                                _ctx.newAudit.data.form.tables[0].rows.length - 1
                            ].description
                        
                        }, null, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.newAudit.data.description)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newAudit.data.options, (option) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: option.name,
                  cols: "4",
                  class: "d-flex align-center justify-center flex-wrap"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_switch, {
                      modelValue: option.value,
                      "onUpdate:modelValue": ($event: any) => ((option.value) = $event),
                      label: option.name,
                      "hide-details": "",
                      disabled: _ctx.newAudit.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM',
                      size: "small"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}